import { cloneDeep } from 'lodash';
import { supabase } from '../supabaseClient';


async function getFloorByWingIdAndProjectId(projectId, wingId) {
    const { data, count, error } = await supabase.from('Inventory').select('*,floorPlanId(*)', { count: 'exact' })
        .eq('projectId', projectId)
        .eq('wingId', wingId)
    if (data) return { data, count };
    else throw error;
}

async function assignNewFloorPlan(floorPlanName, FloorPlanUrl) {
    const { data, count, error } = await supabase.from('FloorPlans')
        .insert([{ name: floorPlanName, floorPlanImgUrl: FloorPlanUrl }])
    if (data) return { data, count };
    else throw error;
}

async function uploadFloorPlanImg(name, file) {
    const { data, error } = await supabase.storage
        .from('floorplans')
        .upload(`${name}.webp`, file, {
            upsert: true,
        });
    if (data) return data;
    else throw error;
}

async function updateFloorPlan(floorPlanId, obj) {
    const { data, error } = await supabase
        .from('FloorPlans')
        .update(obj)
        .eq('floorPlanId', floorPlanId)
    if (data) return data
    else throw error
}

async function updateInventoryForFloorPlans(projectId, WingId, floorNo, floorPlanId) {
    console.log(floorNo);
    const { data, error } = await supabase
        .from('Inventory')
        .update({ floorPlanId: floorPlanId, last_updated_at: Date.now() })
        .eq('projectId', projectId)
        .eq('wingId', WingId)
        .eq('floorNo', floorNo)
    if (data) return data
    else throw error
}

async function getAllFloorPlan(projectId) {
    const { data, count, error } = await supabase.from('FloorPlans')
        .select('*,Inventory!left(*,wingId(*))', { count: 'exact' })
        .eq('Inventory.projectId',projectId)
    if (data) return { data, count };
    else throw error;
}

async function getInventoryFromFloorPlanId(floorPlanId){
    const { data, count, error } = await supabase.from('Inventory')
    .select('*', { count: 'exact' })
    .eq('floorPlanId',floorPlanId)
if (data) return { data, count };
else throw error;
}

async function deleteFloorPlan(floorPlanId) {
    let query = supabase.from('FloorPlans').delete().eq('floorPlanId', floorPlanId)
    const { data, error } = await query;
    if (data) return data;
    else throw error;
  }
  async function deleteUploadedImage(fileName) {
    const { data, error } = await supabase.storage
        .from('floorplans')
  .remove([fileName])
    if (data) return data;
    else throw error;
}

export {
    getFloorByWingIdAndProjectId, assignNewFloorPlan,
    uploadFloorPlanImg, updateFloorPlan, updateInventoryForFloorPlans,
    getAllFloorPlan,getInventoryFromFloorPlanId,deleteFloorPlan,deleteUploadedImage
}